import { render, staticRenderFns } from "./PlanTournament.vue?vue&type=template&id=10cd43e4&scoped=true&"
import script from "./PlanTournament.vue?vue&type=script&lang=js&"
export * from "./PlanTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd43e4",
  null
  
)

export default component.exports